import { promiseState } from "../../helper"
import { sacrament } from "../actions/types"

const { pendingState, fulfilledState, rejectedState } = promiseState

const initialState = {
	isLoading: false,
	message: null,
	errors: [],
	data: [],
	page: {
		totalPage: 0,
		currentPage: 1,
		totalData: 0,
	},
	detail: {},
}

const sacramentChildSubmissionReducer = (state = initialState, action) => {
	switch (action.type) {
		case pendingState(sacrament.GET_CHILD): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(sacrament.GET_CHILD): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(sacrament.GET_CHILD): {
			return Object.assign({}, state, {
				isLoading: false,
				data: action.payload.data.data,
				page: {
					totalPage: action.payload.data.page.totalPage,
					currentPage: action.payload.data.page.currentPage,
					totalData: action.payload.data.page.totalData,
				},
			})
		}

		case pendingState(sacrament.GET_CHILD_DETAIL): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(sacrament.GET_CHILD_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(sacrament.GET_CHILD_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
				detail: action.payload.data.data,
			})
		}

		default:
			return state
	}
}

export default sacramentChildSubmissionReducer
